import React, { useEffect, useState } from "react";
import { fileUpload } from "../../../fileUpload";
import MediaPicker from "../mediaPicker";
import toast from "react-hot-toast";
import IsActive from "../AdminisActive";
import SaveButton from "../AdminButtons";
import {callSection2} from "../../callApi/home"
import { useDispatch } from "react-redux";
import { setLoading } from "../../../Redux/action";
import config from "../../Config.json";

export const Section2 = () => {
  // get the admin data from local storage
  const storedData = localStorage.getItem("adminData") || " {}";
  const adminData = JSON.parse(storedData);
  const AdminId = adminData.AdminId || null;
  const dispatch = useDispatch();
  const [option, setOption] = useState(false);

  // state to show data on frontend
  const [data, setData] = useState({
    AdminId: AdminId,
    heading: "",
    content: "",
    buttonContent: "",
    featureImage: {
      image: "",
      file: "",
      status: "none",
    },
    cards: [
      {
        title: "",
        image: { image: "", file: "", status: "none" },
      },
      {
        title: "",
        image: { image: "", file: "", status: "none" },
      },
      {
        title: "",
        image: { image: "", file: "", status: "none" },
      },
      {
        title: "",
        image: { image: "", file: "", status: "none" },
      },
    ],

    productImages: [
      {
        title: "",
        image: { image: "", file: "", status: "none" },
      },
      {
        title: "",
        image: { image: "", file: "", status: "none" },
      },
      {
        title: "",
        image: { image: "", file: "", status: "none" },
      },
      {
        title: "",
        image: { image: "", file: "", status: "none" },
      },
    ],
  });


  const _data = data;

 
  const updateData = () => {
    setData((data) => ({
      ...data,
      ..._data,
    }));
  };

  const handleImageChange = (file, image) => {
    _data.featureImage.image = image;
    _data.featureImage.file = file;
    _data.featureImage.status = "updated";

    updateData();
  };


  const handleChange = () =>{
      setOption(!option);
    
      if (option) {
        data.ShowInWebSite = 0;
      } else {
        data.ShowInWebSite = 1;
      }
  };
  

  // function to check if any field is empty
  const isEmpty = () => {
    let res = false;
    data?.cards?.forEach((card) => {
      if (card.title.length == 0) {
        res = false;
      } else {
        res = true;
      }
    });
    return res;
  };

  const itIsEmpty = isEmpty();
 

 
  const handleSave = async () => {
    
    let media = {
      featureImage: null,
      cardImages: [null, null, null, null],
      productImages: [null, null, null, null],
    };

    if (
      itIsEmpty &&
      (data.heading !== "" ||
      data.content !== "" ||
      data.buttonContent !== "" ||
      data.content !== "")
    ) {
     
      let updatedCardImages = [];
      data.cards.forEach((card) => {
        if (card.image.status === "updated") {
          updatedCardImages.push(card.image);
        }
      });

      data.productImages.forEach((productImage) => {
        if (productImage.image.status === "updated") {
          updatedCardImages.push(productImage.image);
        }
      });

      if (data.featureImage.status === "updated") {
        updatedCardImages.push(data.featureImage);
      }

    
      if (updatedCardImages.length > 0) {
        const uploadImageRes = await fileUpload(updatedCardImages);
       
        const featureImage =
          data.featureImage.status === "updated"
            ? uploadImageRes.find(
                (x) => x.fileName === data.featureImage.file.name
              )?.key
            : data.featureImage.status === "" || "none" || null
            ? data.media.featureImage
            : data.featureImage.image;

       
        const image1 =
          data.cards[0].image.status === "updated"
            ? uploadImageRes.find(
                (x) => x.fileName === data.cards[0].image.file.name
              )?.key
            : data.cards[0].image.status === "" || "none" || null
            ? data.media.cardImages[0]
            : data.cards[0].image.image;
        const image2 =
          data.cards[1].image.status === "updated"
            ? uploadImageRes.find(
                (x) => x.fileName === data.cards[1].image.file.name
              )?.key
            : data.cards[1].image.status === "" || "none" || null
            ? data.media.cardImages[1]
            : data.cards[1].image.image;
        const image3 =
          data.cards[2].image.status === "updated"
            ? uploadImageRes.find(
                (x) => x.fileName === data.cards[2].image.file.name
              )?.key
            : data.cards[2].image.status === "" || "none" || null
            ? data.media.cardImages[2]
            : data.cards[2].image.image;
        const image4 =
          data.cards[3].image.status === "updated"
            ? uploadImageRes.find(
                (x) => x.fileName === data.cards[3].image.file.name
              )?.key
            : data.cards[3].image.status === "" || "none" || null
            ? data.media.cardImages[3]
            : data.cards[3].image.image;

    
        const image5 =
          data.productImages[0].image.status === "updated"
            ? uploadImageRes.find(
                (x) => x.fileName === data.productImages[0].image.file.name
              )?.key
            : data.productImages[0].image.status === "" || "none" || null
            ? data.media.productImages[0]
            : data.productImages[0].image.image;
        const image6 =
          data.productImages[1].image.status === "updated"
            ? uploadImageRes.find(
                (x) => x.fileName === data.productImages[1].image.file.name
              )?.key
            : data.productImages[1].image.status === "" || "none" || null
            ? data.media.productImages[1]
            : data.productImages[1].image.image;
        const image7 =
          data.productImages[2].image.status === "updated"
            ? uploadImageRes.find(
                (x) => x.fileName === data.productImages[2].image.file.name
              )?.key
            : data.productImages[2].image.status === "" || "none" || null
            ? data.media.productImages[2]
            : data.productImages[2].image.image;
        const image8 =
          data.productImages[3].image.status === "updated"
            ? uploadImageRes.find(
                (x) => x.fileName === data.productImages[3].image.file.name
              )?.key
            : data.productImages[3].image.status === "" || "none" || null
            ? data.media.productImages[3]
            : data.productImages[3].image.image;

        media = {
          featureImage: featureImage,
          cardImages: [image1, image2, image3, image4],
          productImages: [image5, image6, image7, image8],
        };

        saveData(media);

      } else{
        media={
          featureImage: data.media.featureImage,
          cardImages: data.media.cardImages.map((cardImage)=>cardImage),
          productImages: data.media.productImages.map((productImage)=>productImage)
        }

      
        saveData(media)
      }

    } else {
      toast.error("Please fill all values");
    }
  };

  
  let params;
  const saveData = (media) => {
    params = {
      heading: data.heading,
      content: data.content,
      buttonContent: data.buttonContent,
      ShowInWebSite: data.ShowInWebSite,
      cardTitles: data.cards.map((card) => card.title),
      media: media,
      ShowInWebSite: data.ShowInWebSite,
      adminId: data.AdminId
    };

    
    callSection2(params)
    .then((res)=>{
      dispatch(setLoading(false))
      if(res){
        toast.success("Data saved successfully");
      } else{
        toast.error("Something went wrong")
      }
    })
    .catch((error) => {
      dispatch(setLoading(false));
      toast.error("Error saving data. Please try again!");
      console.error("Error saving data:", error);
    });

  };

 
  useEffect(() => {
    dispatch(setLoading(true));
    
    const section2Data = JSON.parse(sessionStorage.getItem("homeApi")).Section2;
    dispatch(setLoading(false));
    
    const { ShowInWebSite, content, media, heading } = section2Data;

    const updatedCards = content?.cardTitles?.map((cardTitle, index) => ({
      title: cardTitle,
      image: { image: config.awsMediaPath + media.cardImages[index] },
    }));

    const updatedProductCards = media?.productImages?.map(
      (productImage, index) => {
        return {
          image: { image: config.awsMediaPath + productImage },
        };
      }
    );

    

    //updating the state
    _data.featureImage = {
      image: config.awsMediaPath + section2Data.media.featureImage,
    };
    _data.heading = heading;
    _data.content = content.content;
    _data.buttonContent = content.buttonContent;
    _data.cards = updatedCards;
    _data.productImages = updatedProductCards;
    _data.media = media;
    setOption(section2Data ? section2Data.ShowInWebSite === 1 : false);
    _data.ShowInWebSite = option ? 1 : 0;
    updateData();
  }, []);

  return (
    <div className="main-container">
      <div className="sec-1">
        <h1 className="sec-1-header">Section 2</h1>
        <section>
          <MediaPicker
            text="Feature image"
            type="image"
            onChange={handleImageChange}
            source={data.featureImage.image}
          />
        </section>
        <div className="input-container">
          <label for="section-2-title">Heading</label>
          <input
            id="section-2-title"
            type="text"
            className="validate heading-input"
            maxLength={100}
            onChange={(e) => {
             
              const { value } = e.target;
              const _data = data;
              _data.heading = value;
              
              updateData();
            }}
            value={data?.heading}
          />
        </div>
        <div className="input-container">
          <label for="section-2-desc">Content</label>
          <textarea
            id="section-2-desc"
            type="text"
            className="validate"
            maxLength={1000}
            onChange={(e) => {
              const { value } = e.target;
              const _data = data;
              _data.content = value;
            
              updateData();
            }}
            value={data?.content}
          />
        </div>
        <div className="input-container">
          <label for="section-2-button">Button text</label>
          <input
            id="section-2-button"
            type="text"
            maxLength={100}
            className="validate"
            onChange={(e) => {
              const { value } = e.target;
              const _data = data;
              _data.buttonContent = value;
              updateData();
            }}
            value={data?.buttonContent}
          />
        </div>
        <div className="card-container">
          <h2>Cards</h2>
          <div className="cards">
            {data?.cards?.map((card, index) => {
              return (
                <div className="carddata" key={index}>
                  <MediaPicker
                    text="Feature image"
                    type="image"
                    onChange={(file, image) => {
                      _data.cards[index].image.image = image;
                      _data.cards[index].imageName = image;
                      _data.cards[index].image.file = file;
                      _data.cards[index].image.status = "updated";
                      updateData();
                    }}
                    source={card?.image.image}
                  />
                  <input
                    id="section-2-card-text"
                    type="text"
                    maxLength={100}
                    placeholder="title"
                    className="validate"
                    onChange={(e) => {
                      const { value } = e.target;
                      const _data = data;
                      _data.cards[index].title = value;
                      updateData();
                    }}
                    value={card?.title}
                  />
                </div>
              );
            })}
          </div>
        </div>

        <div className="product-images-container">
          <h2>Product Images</h2>
          <div className="cards">
            {data?.productImages?.map((productImage, index) => {
              return (
                <MediaPicker
                  text="Feature image"
                  type="image"
                  onChange={(file, image) => {
                    _data.productImages[index].image.image = image;
                    _data.productImages[index].imageName = image;
                    _data.productImages[index].image.file = file;
                    _data.productImages[index].image.status = "updated";
                    updateData();
                  }}
                  source={productImage.image.image}
                />
              );
            })}
          </div>
        </div>
      </div>
      <div className="input-field">
        <label>
          <span>
            <IsActive checked={option} 
            // onChange={() => setOption(!option)} 
            onChange={handleChange}
            />
          </span>
        </label>
      </div>
      <SaveButton onClick={handleSave} />
    </div>
  );
};
